<template>
	<div>
		<div class="scroll-top-container" :class="`scroll-top-container-${tableId}`">
			<div class="scroll-handler" :style="`width: ${scrollWidth}px`"></div>
		</div>
		<div class="table-responsive" :class="`table-responsive-${tableId}`">
			<table
				class="table content-table-view"
				:class="{
					'table-dark': dark,
					'table-bordered': bordered,
					'table-striped': striped,
					'table-hover': hover,
					'table-hover-animation': hoverAnimation,
				}"
				:id="tableId"
			>
				<thead>
					<slot name="TableTitle"></slot>
				</thead>
				<thead>
					<slot name="TableSearch"></slot>
				</thead>
				<tbody>
					<tr v-if="showNoContent" class="state-row">
						<td :colspan="99" class="state-cell">
							<div class="table-loader" aria-label="در حال بارگذاری">
								<span></span><span></span><span></span>
							</div>
						</td>
					</tr>
					<tr v-else-if="showNoData" class="state-row">
						<td :colspan="99" class="state-cell">
							<EmptyState />
						</td>
					</tr>
					<slot v-else name="TableBody"></slot>
				</tbody>
				<thead>
					<tr v-if="showNoContent">
						<!-- <th colspan="100%" class="no-content-th"></th> -->
					</tr>
				</thead>
				<!-- <thead v-if="showFooterColumn">
					<slot name="TableTitle"></slot>
				</thead> -->
			</table>
		</div>
	</div>
</template>

<script>
import EmptyState from '../EmptyState/index.vue';
export default {
	components: {
		EmptyState,
	},
	props: {
		dark: {
			type: Boolean,
		},
		hover: {
			type: Boolean,
		},
		hoverAnimation: {
			type: Boolean,
		},
		bordered: {
			type: Boolean,
		},
		striped: {
			type: Boolean,
		},
		showFooterColumn: {
			type: Boolean,
			default: true,
		},
		showNoContent: {
			type: Boolean,
		},
		showNoData: {
			type: Boolean,
		},
		tableId: {
			type: String,
			default: 'mainTable',
		},
	},
	data() {
		return {
			scrollWidth: 0,
		};
	},
	
	methods: {
		tableResponsiveScroll() {
			document.querySelector(`.table-responsive-${this.tableId}`).addEventListener('scroll', () => {
				document.querySelector(`.scroll-top-container-${this.tableId}`).scrollLeft =
					document.querySelector(`.table-responsive-${this.tableId}`).scrollLeft;
			});
		},
		scrollTopContainerScroll() {
			document
				.querySelector(`.scroll-top-container-${this.tableId}`)
				.addEventListener('scroll', () => {
					document.querySelector(`.table-responsive-${this.tableId}`).scrollLeft =
						document.querySelector(`.scroll-top-container-${this.tableId}`).scrollLeft;
				});
		},
	},
	mounted() {
		this.tableResponsiveScroll();
		this.scrollTopContainerScroll();
		// if(this.showNoContent === true) {

		// }
		console.log('asdasd',this.showNoData)

	},
	updated() {
		this.$nextTick(() => {
			this.scrollWidth = document.getElementById(this.tableId).getBoundingClientRect().width;
		});
	},
	beforeDestroy() {
		const scrollTopContainer = document.querySelector(`.scroll-top-container-${this.tableId}`);
		const tableResponsive = document.querySelector(`.table-responsive-${this.tableId}`);
		if (scrollTopContainer && tableResponsive) {
			scrollTopContainer.removeEventListener('scroll', this.scrollTopContainerScroll);
			tableResponsive.removeEventListener('scroll', this.tableResponsiveScroll);
		}
	},
};
</script>

<style scoped lang="scss">
.scroll-top-container {
	overflow-x: auto;
	overflow-y: hidden;
	width: 100%;

	&::-webkit-scrollbar {
		height: 6px;
	}

	&::-webkit-scrollbar-track {
		box-shadow: none;
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 8px;
		background-color: darkgrey;
	}
	.scroll-handler {
		height: 2px;
	}
}
table thead th {
	vertical-align: middle;
	&:first-child {
		border-radius: 0px 10px 0px 0px;
	}
	&:last-child {
		border-radius: 10px 0px 0px 0px;
	}
}
tbody {
	background: #fff;
}
table tr th {
	font-size: 13px !important;
	font-weight: 700;
	color: #46536b;
	background-color: #eef3fb;
	border-bottom: 2px solid #dde7f5 !important;
	min-width: 100px;
	padding-top: 13px;
	padding-bottom: 13px;
	letter-spacing: 0.2px;
}
table tr th,
table tr td {
	text-align: center !important;
	border: none;
	width: 0;
	vertical-align: middle;
}

/* Empty / loading state rows */
.state-row td {
	background: #fff;
}
.state-cell {
	padding: 0 !important;
	text-align: center !important;
}
.table-loader {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 40px 0;

	span {
		width: 11px;
		height: 11px;
		border-radius: 50%;
		background: linear-gradient(135deg, #3aa6a6, #2d8b8b);
		animation: lemaBounce 0.9s ease-in-out infinite both;

		&:nth-child(1) {
			animation-delay: -0.28s;
		}
		&:nth-child(2) {
			animation-delay: -0.14s;
		}
	}
}
@keyframes lemaBounce {
	0%,
	80%,
	100% {
		transform: scale(0.5);
		opacity: 0.4;
	}
	40% {
		transform: scale(1);
		opacity: 1;
	}
}

.table-responsive {
	overflow-y: hidden;
	&::-webkit-scrollbar {
		height: 6px;
	}

	&::-webkit-scrollbar-track {
		box-shadow: none;
	}

	&::-webkit-scrollbar-thumb {
		border-radius: 8px;
		background-color: darkgrey;
	}
}
.loading-img {
	width: 24px;
}
</style>
